export default __webpack_public_path__ + "static/media/crossroads9.e975bb78.webp";